import {useState} from 'react';
import styles from './countriesTable.module.scss';
import {Search, Button} from '@dabafinance/react-components';
import {Table, Spin} from 'antd';
import {useNavigate} from 'react-router-dom';
import {GET_ALL_TOPICS} from 'graphql/queries/interest';
import {useQuery, useMutation} from '@apollo/client';
import pageNotFound from 'images/pageNotFound.png';
import {DELETE_TOPIC} from 'graphql/mutations/interest';
import {toast} from 'react-toastify';
import trash from 'images/trash-can-outline.svg';
import {useSelector} from 'react-redux';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';

export default function CountriesTable() {
  const [topicCountries, setTopicCountries] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const navigate = useNavigate();

  const {loading} = useQuery(GET_ALL_TOPICS, {
    variables: {
      type: 'COUNTRY',
    },
    onCompleted: data => setTopicCountries(data?.getAllTopics),
    onError: error => toast.error(error.message),
  });

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Topics),
  );

  const handleSearch = term => {
    if (term != '') {
      const searchList = topicCountries.filter(data => {
        return Object.values(data)
          .join(' ')
          .toLowerCase()
          .includes(term.toLowerCase());
      });
      setSearchData(searchList);
    } else {
      setSearchData(topicCountries);
    }
  };

  const [deleteTopic] = useMutation(DELETE_TOPIC);

  const handleDelete = id => {
    deleteTopic({
      variables: {
        topicId: id,
      },
      update(cache) {
        cache.modify({
          fields: {
            getAllTopics() {},
          },
        });
      },
    })
      .then(({data: {deleteTopic}}) => {
        if (deleteTopic.__typename === 'Error') {
          toast.error(deleteTopic.message);
        } else {
          toast.success('Topic deleted Successfully');
        }
      })
      .catch(error => toast.error(error));
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <img src={record.icon} alt="" />
          <span>{record.name}</span>
        </div>
      ),
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <span>{record.type}</span>
        </div>
      ),
    },

    {
      title: 'Users Interested',
      dataIndex: 'usersInterested',
      key: 'usersInterested',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <span>{record.numOfFollowers}</span>
        </div>
      ),
    },
    {
      title: 'Companies',
      dataIndex: 'companies',
      key: 'companies',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <span>{record.relatedCompanies.length}</span>
        </div>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'operation',
      key: 'actions',
      render: (text, record) => (
        <Button
          type="secondary"
          label="View details"
          disabled={!tabOperations?.update}
          className={styles.button}
          onClick={() => navigate(`/dashboard/interest/${record.id}`)}
        />
      ),
    },
  ];

  if (tabOperations?.delete) {
    columns.push({
      title: '',
      dataIndex: 'operation',
      key: 'actions',
      render: (text, record) => (
        <img
          onClick={() => {
            handleDelete(record.id);
          }}
          className={styles.trash}
          src={trash}
          alt=""
        />
      ),
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>All Topic Countries</h2>
        <div className={styles.actions}>
          <Search
            id="search-interests"
            placeholder="Search Topic Countries"
            onChange={handleSearch}
            className={styles.search}
          />
        </div>
      </div>
      <div>
        {topicCountries.length ? (
          <Table
            dataSource={searchData.length < 1 ? topicCountries : searchData}
            columns={columns}
          />
        ) : (
          <div className={styles['no-update']}>
            <img src={pageNotFound} alt="" />
            <h1>No Topic Countries</h1>
          </div>
        )}
      </div>
    </div>
  );
}
